// Translation: Register > Landing > Form > TOS dialog (English)
export default Object.freeze({})
